
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useParams } from "react-router-dom"
import { BaseUrl } from '../../helper/BaseUrl';
import { DateConvert } from "../../helper/DateConvert";
import { fetchJson } from '../../helper/fetchJson';

const relatedBlogs = (blogs, slug) =>
  (Array.isArray(blogs) ? blogs : []).filter((item) => item.slug !== slug).slice(0, 3);

export default function AiRelatedPost({ initialData }) {
  const { slug } = useParams();
  const [recentData, setRecentData] = useState(() => relatedBlogs(initialData, slug));

  useEffect(() => {
    let active = true;

    if (initialData?.length) {
      setRecentData(relatedBlogs(initialData, slug));
    } else {
      fetchJson(`${BaseUrl}/api/aiblogs`)
        .then((result) => {
          if (!active) return;
          if (result.blogs === false) {
            throw new Error(`API error: ${result.message}`);
          }
          setRecentData(relatedBlogs(result.blogs, slug));
        })
        .catch((error) => console.error("Fetch error:", error.message));
    }

    return () => {
      active = false;
    };
  }, [slug, initialData]);


  if (!recentData.length) return null;


  return (
    <>
      <section className="blog-listing recent-post">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-8">
              <div className="recent-text heading-gap heading-center ">
                <h2 className="heading">You might also like</h2>
              </div>
            </div>
          </div>
          <div className="row">
            {recentData.map((item, index) => (
              <div key={index} className="col-sm-6 col-md-6 col-lg-4 blog-card">
                <div className="blog-card-inner">
                  <img src={`${BaseUrl}${item.image}`} className="img-responsive" alt={item.name} loading="lazy" />
                  <div className="blog-info">
                    <div className="blog-meta">
                      <img src={`${BaseUrl}${item.author_image}`} className="img-responsive" alt={item.author_name} loading="lazy" />
                      Written by <span>{item.author_name}</span>
                    </div>
                    <div className="heading">{item?.name?.slice(0,80) + "..."} </div>
                    <div className="info-bottom">
                      <div className="date">
                        <div className="blog-date">{DateConvert(item.date)}</div>
                      </div>
                      <div className="link-text">
                        <Link className="hover-link" to={`/blogs/${item.slug}`} >
                          <i className="fa-solid fa-arrow-right"></i>
                           <span className="sr-only">Read more about {item.name}</span>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="row">
            <div className="col-md-12">
              <div className="load-more">
                <Link className="theme-btn" to={"/blogs"} > <span>View More</span></Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
